export enum ProjectType {
    IMAGE_RECOGNITION = "IMAGE_RECOGNITION",
    OBJECT_DETECTION = "OBJECT_DETECTION"
}